<script setup lang="ts">
import Axios from 'axios';

const { url } = defineProps<{
    url: string;
}>();

const loading = ref(false);
const terms = ref([]);
const isEn = ref(true);
const renderedRules = computed(() =>
    terms.value.map(
        (item: string) =>
            `<p class="${
                /^(.*)[؀-ۿ]+$/.test(item) ? 'fa-p' : 'en-p'
            }">${item}</p>`
    )
);
onMounted(async () => {
    try {
        loading.value = true;
        const { data } = await Axios.get(url);
        isEn.value = !/^[؀-ۿ\s]+$/.test(data);
        terms.value = data
            .split('<b>')
            .filter((item: string) => item)
            .map((item: string) => `<b>${item}`);
        loading.value = false;
    } catch (ex) {
        (await handleException(ex, { showDefaultError: false })) ||
            swal({
                icon: 'warning',
                title: 'خطا!',
                text: 'مشکلی در دریافت داده پیش آمده!',
                confirmButtonText: 'باشه',
            });
    }
});
</script>

<template>
    <div
        class="loadable-terms-container"
        :class="{ 'all-en': isEn }"
        :dir="isEn ? 'ltr' : 'rtl'"
    >
        <mr-loading v-if="loading" />
        <ul v-else>
            <li v-for="(item, key) in renderedRules" :key v-html="item" />
        </ul>
    </div>
</template>

<style lang="scss" scoped>
@include scroll-fantasy;
.loadable-terms-container {
    @include en-num;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    max-width: 100%;
    overflow-y: scroll;
    padding-right: 8px;
    margin-right: -8px;
    &.all-en :deep() {
        * {
            @include en-num;
            text-align: left;
        }
    }
    @include desktop-only {
        max-height: 500px;
    }

    :deep() {
        * {
            @include set-font($important: true);
            @include fa-num;
        }
        .en-p {
            @include en-num;
            text-align: left;
        }
        .fa-p {
            text-align: right;
        }
    }
}
</style>
